/**
 * PlaylistResultRow Component
 *
 * Single row in the playlist search results table.
 * Displays date, time, title, and artist for a played track.
 */

import { Component } from "solid-js";
import type { MetadataHistoryEntry } from "~/types/metadataHistory";
import { formatDate, formatTime } from "../utils";
import styles from "./PlaylistResultRow.module.css";

export interface PlaylistResultRowProps {
  /** The metadata entry to display */
  entry: MetadataHistoryEntry;
  /** Whether to use alternate row styling */
  isAlternate: boolean;
}

const PlaylistResultRow: Component<PlaylistResultRowProps> = (props) => {
  return (
    <div class={styles.tableRow} classList={{ [styles.alternate]: props.isAlternate }}>
      <span class={styles.cellDate}>{formatDate(props.entry.startDate)}</span>
      <span class={styles.cellTime}>{formatTime(props.entry.startDate)}</span>
      <span class={styles.cellTitle}>{props.entry.title}</span>
      <span class={styles.cellArtist}>{props.entry.artist}</span>
    </div>
  );
};

export default PlaylistResultRow;
